import Gallery from "../blocks/gallery";

const SinglePost = {
  init() {
    new Gallery(".gallery");
  },
};

export default SinglePost;
